// src/components/MiniLogo.js

import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

const LogoContainer = styled(motion.button)`
  position: fixed;
  top: clamp(1.5rem, 3vw, 2rem);
  right: clamp(1.5rem, 3vw, 2rem);
  z-index: 10;
  cursor: pointer;
  background: transparent;
  border: 0;
  padding: 0;
  background: transparent;
  border: none;
  padding: 0;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  will-change: opacity, transform;

  @media (max-width: 768px) {
    height: 35px;
    width: 35px;
  }
`;

const LogoImage = styled.img`
  height: 40px; 
  width: auto;

  position: absolute;

  @media (max-width: 768px) {
    height: 35px;
  }
`;


 const MiniLogo = ({ onClick, concealed = false }) => {
   return (
     <LogoContainer
      aria-label="Open menu"
      data-hidden={concealed ? 'true' : 'false'}
      style={{ pointerEvents: concealed ? 'none' : 'auto' }}
      onClick={onClick}
       initial={{ opacity: 0, y: -20 }}
       animate={{
        opacity: concealed ? 0 : 1,
        y: concealed ? -18 : 0,
      }}
       exit={{ opacity: 0, y: -20 }}
       transition={{ duration: 0.28, ease: [0.22, 0.61, 0.36, 1] }}
     >
       <LogoImage src="/makdis_logo.png" alt="MAKDIS Logo" />
     </LogoContainer>
   );
 };

export default MiniLogo;
